function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
/**
 * Unlock fee — amount locked at set-time; wallet funding attached silently
 * immediately before CHECKSIG / CHECKMULTISIG (and broadcast).
 *
 * UI-owned unlock_transaction_base stays free of fee inputs / change.
 * Funded slips live only on unlock_transaction_final.
 */

var Slip = require('./../../../../lib/saito/slip')["default"];
var _require = require('./script_build'),
  build_test_script_from_create = _require.build_test_script_from_create,
  lockingView = _require.lockingView;
var UNLOCK_SIGNED_ERROR = 'This transaction has already been signed and can no longer be modified. Restart Unlock Transaction to make changes.';
var UNLOCK_FEE_LOCKED_ERROR = 'Transaction fee is already set and cannot be changed. Restart Unlock Transaction to choose a different fee.';
function hasUnlockFee(mod) {
  return !!(mod !== null && mod !== void 0 && mod.unlock_fee && mod.unlock_fee.feeSaito != null && String(mod.unlock_fee.feeSaito) !== '');
}

/** Default zero fee set at unlock-tx creation — still replaceable until a positive fee is chosen or the tx is signed. */
function isDefaultZeroUnlockFee(mod) {
  return hasUnlockFee(mod) && String(mod.unlock_fee.feeSaito).trim() === '0';
}
function canChangeUnlockFee(mod) {
  return isUnlockEditable(mod) && (!hasUnlockFee(mod) || isDefaultZeroUnlockFee(mod));
}

/**
 * Unlock txs default to a zero fee when created. Broadcast / signing use this
 * value unless the user sets a positive fee first.
 */
function ensureDefaultUnlockFee(mod) {
  if (hasUnlockFee(mod)) {
    return mod.unlock_fee;
  }
  mod.unlock_fee = {
    feeSaito: '0',
    feeNolan: '0'
  };
  return mod.unlock_fee;
}
function isUnlockEditable(mod) {
  return (mod === null || mod === void 0 ? void 0 : mod.unlock_transaction_editable) !== false;
}
function assertUnlockEditable(mod) {
  if (!isUnlockEditable(mod)) {
    throw new Error(UNLOCK_SIGNED_ERROR);
  }
}

/** Witness signature field paths may still be filled after the tx is locked. */
function isWitnessSignaturePath(path) {
  var p = String(path || '');
  return /(^|\.)witness\.(signature|signatures)(\.|$)/.test(p);
}
function assertUnlockMutablePath(mod, path) {
  if (isUnlockEditable(mod)) {
    return;
  }
  if (isWitnessSignaturePath(path)) {
    return;
  }
  throw new Error(UNLOCK_SIGNED_ERROR);
}
function lockedInputCount(mod) {
  var ctx = mod === null || mod === void 0 ? void 0 : mod.unlockContext;
  if ((ctx === null || ctx === void 0 ? void 0 : ctx.assetType) === 'nft' && Array.isArray(ctx.lockedNftSlips) && ctx.lockedNftSlips.length === 3) {
    return 3;
  }
  return ctx !== null && ctx !== void 0 && ctx.lockedSlip ? 1 : 0;
}

/** User-created outputs on the editable base (fee change is never attached here). */
function userOutputs(mod) {
  var _mod$unlock_transacti;
  return Array.isArray(mod === null || mod === void 0 || (_mod$unlock_transacti = mod.unlock_transaction_base) === null || _mod$unlock_transacti === void 0 ? void 0 : _mod$unlock_transacti.to) ? mod.unlock_transaction_base.to : [];
}
function formatFeeAmount(app, amount) {
  try {
    var _app$wallet;
    if (typeof (app === null || app === void 0 || (_app$wallet = app.wallet) === null || _app$wallet === void 0 ? void 0 : _app$wallet.convertNolanToSaito) === 'function') {
      return app.wallet.convertNolanToSaito(BigInt(amount || 0));
    }
    return String(amount || '0');
  } catch (_err) {
    return String(amount || '0');
  }
}

/** Normalize wallet balance / fee values that may arrive as bigint, number, or string. */
function toNolanBigInt(value) {
  if (typeof value === 'bigint') {
    return value;
  }
  if (typeof value === 'number' && Number.isFinite(value)) {
    return BigInt(Math.trunc(value));
  }
  if (value == null || value === '') {
    return BigInt(0);
  }
  try {
    return BigInt(String(value).trim());
  } catch (_err) {
    return BigInt(0);
  }
}
function readSpendableWalletNolan(_x) {
  return _readSpendableWalletNolan.apply(this, arguments);
}
/** Debug snapshot for fee-funding failures (safe to leave enabled while diagnosing). */
function _readSpendableWalletNolan() {
  _readSpendableWalletNolan = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(app) {
    var _app$core;
    var _t, _t2, _t3;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          if (!(typeof (app === null || app === void 0 || (_app$core = app.core) === null || _app$core === void 0 || (_app$core = _app$core.wallet) === null || _app$core === void 0 ? void 0 : _app$core.getAvailableBalance) === 'function')) {
            _context.n = 4;
            break;
          }
          _context.p = 1;
          _t = toNolanBigInt;
          _context.n = 2;
          return app.core.wallet.getAvailableBalance();
        case 2:
          return _context.a(2, _t(_context.v));
        case 3:
          _context.p = 3;
          _t2 = _context.v;
        case 4:
          _t3 = toNolanBigInt;
          _context.n = 5;
          return app.wallet.getBalance();
        case 5:
          return _context.a(2, _t3(_context.v));
      }
    }, _callee, null, [[1, 3]]);
  }));
  return _readSpendableWalletNolan.apply(this, arguments);
}
function debugFeeFundWalletState(_x2, _x3) {
  return _debugFeeFundWalletState.apply(this, arguments);
}
function _debugFeeFundWalletState() {
  _debugFeeFundWalletState = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(app, label) {
    var extra,
      snap,
      _app$wallet2,
      _app$wallet3,
      _app$core2,
      _app$wallet4,
      _app$wallet5,
      _app$options,
      slips,
      _app$options2,
      _args2 = arguments,
      _t4,
      _t5,
      _t6,
      _t7,
      _t8,
      _t9,
      _t0,
      _t1,
      _t10,
      _t11,
      _t12,
      _t13;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.p = _context2.n) {
        case 0:
          extra = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : {};
          snap = _objectSpread(_objectSpread({
            label: label
          }, extra), {}, {
            ts: Date.now()
          });
          _context2.p = 1;
          if (!(typeof (app === null || app === void 0 || (_app$wallet2 = app.wallet) === null || _app$wallet2 === void 0 ? void 0 : _app$wallet2.getPublicKey) === 'function')) {
            _context2.n = 3;
            break;
          }
          _context2.n = 2;
          return app.wallet.getPublicKey();
        case 2:
          _t4 = _context2.v;
          _context2.n = 4;
          break;
        case 3:
          _t4 = null;
        case 4:
          snap.publicKey = _t4;
          _context2.n = 6;
          break;
        case 5:
          _context2.p = 5;
          _t5 = _context2.v;
          snap.publicKeyError = (_t5 === null || _t5 === void 0 ? void 0 : _t5.message) || String(_t5);
        case 6:
          _context2.p = 6;
          if (!(typeof (app === null || app === void 0 || (_app$wallet3 = app.wallet) === null || _app$wallet3 === void 0 ? void 0 : _app$wallet3.getBalance) === 'function')) {
            _context2.n = 8;
            break;
          }
          _t7 = String;
          _context2.n = 7;
          return app.wallet.getBalance();
        case 7:
          _t6 = _t7(_context2.v);
          _context2.n = 9;
          break;
        case 8:
          _t6 = null;
        case 9:
          snap.balanceGetBalance = _t6;
          _context2.n = 11;
          break;
        case 10:
          _context2.p = 10;
          _t8 = _context2.v;
          snap.balanceGetBalanceError = (_t8 === null || _t8 === void 0 ? void 0 : _t8.message) || String(_t8);
        case 11:
          _context2.p = 11;
          if (!(typeof (app === null || app === void 0 || (_app$core2 = app.core) === null || _app$core2 === void 0 || (_app$core2 = _app$core2.wallet) === null || _app$core2 === void 0 ? void 0 : _app$core2.getAvailableBalance) === 'function')) {
            _context2.n = 13;
            break;
          }
          _t0 = String;
          _context2.n = 12;
          return app.core.wallet.getAvailableBalance();
        case 12:
          _t9 = _t0(_context2.v);
          _context2.n = 17;
          break;
        case 13:
          if (!(typeof (app === null || app === void 0 || (_app$wallet4 = app.wallet) === null || _app$wallet4 === void 0 ? void 0 : _app$wallet4.getAvailableBalance) === 'function')) {
            _context2.n = 15;
            break;
          }
          _t10 = String;
          _context2.n = 14;
          return app.wallet.getAvailableBalance();
        case 14:
          _t1 = _t10(_context2.v);
          _context2.n = 16;
          break;
        case 15:
          _t1 = null;
        case 16:
          _t9 = _t1;
        case 17:
          snap.balanceGetAvailable = _t9;
          _context2.n = 19;
          break;
        case 18:
          _context2.p = 18;
          _t11 = _context2.v;
          snap.balanceGetAvailableError = (_t11 === null || _t11 === void 0 ? void 0 : _t11.message) || String(_t11);
        case 19:
          _context2.p = 19;
          if (!(typeof (app === null || app === void 0 || (_app$wallet5 = app.wallet) === null || _app$wallet5 === void 0 ? void 0 : _app$wallet5.getSlips) === 'function')) {
            _context2.n = 21;
            break;
          }
          _context2.n = 20;
          return app.wallet.getSlips();
        case 20:
          _t12 = _context2.v;
          _context2.n = 22;
          break;
        case 21:
          _t12 = Array.isArray(app === null || app === void 0 || (_app$options = app.options) === null || _app$options === void 0 || (_app$options = _app$options.wallet) === null || _app$options === void 0 ? void 0 : _app$options.slips) ? app.options.wallet.slips : [];
        case 22:
          slips = _t12;
          snap.slipCount = Array.isArray(slips) ? slips.length : 0;
          snap.slips = (Array.isArray(slips) ? slips : []).map(function (s) {
            var _j$slipType, _j$slipIndex;
            var j = typeof (s === null || s === void 0 ? void 0 : s.toJson) === 'function' ? s.toJson() : s;
            return {
              amount: (j === null || j === void 0 ? void 0 : j.amount) != null ? String(j.amount) : null,
              blockId: (j === null || j === void 0 ? void 0 : j.blockId) != null ? String(j.blockId) : (j === null || j === void 0 ? void 0 : j.block_id) != null ? String(j.block_id) : null,
              spent: j === null || j === void 0 ? void 0 : j.spent,
              slipType: (_j$slipType = j === null || j === void 0 ? void 0 : j.slipType) !== null && _j$slipType !== void 0 ? _j$slipType : j === null || j === void 0 ? void 0 : j.slip_type,
              txIndex: (j === null || j === void 0 ? void 0 : j.txIndex) != null ? String(j.txIndex) : (j === null || j === void 0 ? void 0 : j.tx_ordinal) != null ? String(j.tx_ordinal) : null,
              slipIndex: (_j$slipIndex = j === null || j === void 0 ? void 0 : j.slipIndex) !== null && _j$slipIndex !== void 0 ? _j$slipIndex : j === null || j === void 0 ? void 0 : j.slip_index,
              utxokey: j !== null && j !== void 0 && j.utxokey ? String(j.utxokey).slice(0, 24) + '…' : null
            };
          });
          _context2.n = 24;
          break;
        case 23:
          _context2.p = 23;
          _t13 = _context2.v;
          snap.slipsError = (_t13 === null || _t13 === void 0 ? void 0 : _t13.message) || String(_t13);
        case 24:
          try {
            snap.optionsSlipCount = Array.isArray(app === null || app === void 0 || (_app$options2 = app.options) === null || _app$options2 === void 0 || (_app$options2 = _app$options2.wallet) === null || _app$options2 === void 0 ? void 0 : _app$options2.slips) ? app.options.wallet.slips.length : null;
          } catch (_err) {
            /* ignore */
          }
          console.warn('[RustScript fee-fund]', snap);
          return _context2.a(2, snap);
      }
    }, _callee2, null, [[19, 23], [11, 18], [6, 10], [1, 5]]);
  }));
  return _debugFeeFundWalletState.apply(this, arguments);
}
function slipToJson(slip) {
  if (!slip) {
    return null;
  }
  if (typeof slip.toJson === 'function') {
    return slip.toJson();
  }
  return {
    publicKey: slip.publicKey,
    amount: slip.amount,
    type: slip.type,
    blockId: slip.blockId,
    txOrdinal: slip.txOrdinal,
    index: slip.index
  };
}
function slipAmountPositive(slip) {
  try {
    return BigInt((slip === null || slip === void 0 ? void 0 : slip.amount) || 0) > BigInt(0);
  } catch (_err) {
    return false;
  }
}

/**
 * Assign output slip_index values the same way Transaction::sign does,
 * so CHECKSIG's p2sh_auth_hash matches the broadcast transaction.
 */
function assignOutputSlipIndices(tx) {
  if (!tx) {
    return;
  }
  var outputs = Array.isArray(tx.to) ? tx.to : [];
  for (var i = 0; i < outputs.length; i++) {
    outputs[i].index = i;
  }
}

/**
 * Blake3 hex over concatenate(serialize_output_for_signature) for every output.
 * Mirrors saito-core get_p2sh_auth_hash / Slip::serialize_output_for_signature.
 */
function getP2shAuthHash(app, tx) {
  var _app$crypto, _app$crypto2;
  if (!tx || typeof (app === null || app === void 0 || (_app$crypto = app.crypto) === null || _app$crypto === void 0 ? void 0 : _app$crypto.hash) !== 'function' || typeof (app === null || app === void 0 || (_app$crypto2 = app.crypto) === null || _app$crypto2 === void 0 ? void 0 : _app$crypto2.fromBase58) !== 'function') {
    throw new Error('Cannot compute authorization hash for this transaction.');
  }
  assignOutputSlipIndices(tx);
  var parts = [];
  var outputs = Array.isArray(tx.to) ? tx.to : [];
  for (var i = 0; i < outputs.length; i++) {
    var _slip$index, _slip$type;
    var slip = outputs[i];
    var pkB58 = String((slip === null || slip === void 0 ? void 0 : slip.publicKey) || (slip === null || slip === void 0 ? void 0 : slip.public_key) || '');
    if (!pkB58) {
      throw new Error('Unlock output is missing a public key.');
    }
    var pkBytes = Buffer.from(app.crypto.fromBase58(pkB58), 'hex');
    var amountBuf = Buffer.alloc(8);
    amountBuf.writeBigUInt64BE(toNolanBigInt(slip === null || slip === void 0 ? void 0 : slip.amount));
    parts.push(pkBytes);
    parts.push(amountBuf);
    parts.push(Buffer.from([Number((_slip$index = slip === null || slip === void 0 ? void 0 : slip.index) !== null && _slip$index !== void 0 ? _slip$index : i) & 0xff]));
    parts.push(Buffer.from([Number((_slip$type = slip === null || slip === void 0 ? void 0 : slip.type) !== null && _slip$type !== void 0 ? _slip$type : 0) & 0xff]));
  }
  return String(app.crypto.hash(Buffer.concat(parts)));
}
function buildP2shAuthMessage(app, message, tx) {
  var msg = String(message !== null && message !== void 0 ? message : '');
  if (!msg) {
    throw new Error('No signable message found for this opcode.');
  }
  var hash = getP2shAuthHash(app, tx);
  return "".concat(msg, "|").concat(hash);
}

/**
 * Clear CHECKSIG / CHECKMULTISIG witness signatures (placeholders restored).
 */
function clearSignatureWitnesses(node) {
  if (!node || _typeof(node) !== 'object') {
    return;
  }
  if (Array.isArray(node)) {
    node.forEach(clearSignatureWitnesses);
    return;
  }
  var op = String(node.op || '').toLowerCase();
  if (op === 'and' || op === 'or' || op === 'then' || op === 'not') {
    var args = Array.isArray(node.args) ? node.args : [];
    args.forEach(clearSignatureWitnesses);
    return;
  }
  if (!node.witness || _typeof(node.witness) !== 'object' || Array.isArray(node.witness)) {
    return;
  }
  if (op === 'checksig' && Object.prototype.hasOwnProperty.call(node.witness, 'signature')) {
    node.witness.signature = '<signature>';
  }
  if (op === 'checkmultisig' && Array.isArray(node.witness.signatures)) {
    node.witness.signatures = node.witness.signatures.map(function () {
      return '<signature>';
    });
  }
}
function invalidateUnlockSignatures(mod, mainUi) {
  if (!mod || typeof mod.getScript !== 'function') {
    return;
  }
  var script = mod.getScript();
  clearSignatureWitnesses(script);
  var opcodes = mod.opcodes;
  var merged = build_test_script_from_create(lockingView(script), script, opcodes);
  mod.setScript(merged);
  if (mainUi) {
    mainUi.executionStatus = {
      attempted: false,
      success: false
    };
    mainUi.validationDisplay = null;
  }
}

/**
 * Store and lock the fee amount only. Does not attach wallet UTXOs.
 */
function lockUnlockFeeAmount(_x4, _x5, _x6) {
  return _lockUnlockFeeAmount.apply(this, arguments);
}
/** @deprecated Use lockUnlockFeeAmount — kept for callers during rename. */
function _lockUnlockFeeAmount() {
  _lockUnlockFeeAmount = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(app, mod, feeSaito) {
    var feeText, feeNum, feeNolan, balance, have;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          assertUnlockEditable(mod);
          if (canChangeUnlockFee(mod)) {
            _context3.n = 1;
            break;
          }
          throw new Error(UNLOCK_FEE_LOCKED_ERROR);
        case 1:
          if (mod !== null && mod !== void 0 && mod.unlock_transaction_base) {
            _context3.n = 2;
            break;
          }
          throw new Error('Unlock transaction is not ready.');
        case 2:
          feeText = String(feeSaito || '').trim();
          feeNum = Number(feeText);
          if (!(!feeText || !Number.isFinite(feeNum) || feeNum <= 0)) {
            _context3.n = 3;
            break;
          }
          throw new Error('Enter a valid fee greater than zero.');
        case 3:
          feeNolan = toNolanBigInt(app.wallet.convertSaitoToNolan(feeText));
          if (!(feeNolan <= BigInt(0))) {
            _context3.n = 4;
            break;
          }
          throw new Error('Enter a valid fee greater than zero.');
        case 4:
          _context3.n = 5;
          return readSpendableWalletNolan(app);
        case 5:
          balance = _context3.v;
          if (!(balance < feeNolan)) {
            _context3.n = 6;
            break;
          }
          have = app.wallet.convertNolanToSaito(balance);
          throw new Error("Insufficient wallet balance for this fee. Available: ".concat(have, " SAITO. Network fees are paid from your wallet, not from the locked script inputs."));
        case 6:
          // Replacing the default zero fee invalidates any prior funded final clone.
          mod.unlock_transaction_final = null;
          mod.unlock_fee = {
            feeSaito: feeText,
            feeNolan: feeNolan.toString()
          };
          return _context3.a(2, mod.unlock_fee);
      }
    }, _callee3);
  }));
  return _lockUnlockFeeAmount.apply(this, arguments);
}
function applyUnlockFee(_x7, _x8, _x9) {
  return _applyUnlockFee.apply(this, arguments);
}
/**
 * Silently fund the stored fee onto a finalized clone.
 * Called once before the first CHECKSIG/CHECKMULTISIG; reused thereafter.
 */
function _applyUnlockFee() {
  _applyUnlockFee = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(app, mod, feeSaito) {
    var _mainUi,
      _args4 = arguments;
    return _regenerator().w(function (_context4) {
      while (1) switch (_context4.n) {
        case 0:
          _mainUi = _args4.length > 3 && _args4[3] !== undefined ? _args4[3] : null;
          return _context4.a(2, lockUnlockFeeAmount(app, mod, feeSaito));
      }
    }, _callee4);
  }));
  return _applyUnlockFee.apply(this, arguments);
}
function ensureUnlockFeeFunded(_x0, _x1) {
  return _ensureUnlockFeeFunded.apply(this, arguments);
}
/**
 * Prepare the finalized funded transaction for CHECKSIG / CHECKMULTISIG.
 * Returns the auth message (message|p2sh_auth_hash) to sign.
 */
function _ensureUnlockFeeFunded() {
  _ensureUnlockFeeFunded = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(app, mod) {
    var _mod$unlock_fee, _mod$unlock_fee2;
    var base, feeNolan, _finalTx, balance, have, me, feeTx, _err$cause, balanceAfter, _have, detail, finalTx, feeInputs, fundedInputCount, skippedFeeInputs, i, stored, changeOuts, _i, _stored, _t14;
    return _regenerator().w(function (_context5) {
      while (1) switch (_context5.p = _context5.n) {
        case 0:
          ensureDefaultUnlockFee(mod);
          if (!mod.unlock_transaction_final) {
            _context5.n = 1;
            break;
          }
          assignOutputSlipIndices(mod.unlock_transaction_final);
          return _context5.a(2, mod.unlock_transaction_final);
        case 1:
          base = mod.unlock_transaction_base;
          if (base) {
            _context5.n = 2;
            break;
          }
          throw new Error('Unlock transaction is not ready.');
        case 2:
          feeNolan = toNolanBigInt(mod.unlock_fee.feeNolan);
          if (!(feeNolan <= BigInt(0))) {
            _context5.n = 4;
            break;
          }
          if (!(typeof mod.cloneTransactionSkeleton !== 'function')) {
            _context5.n = 3;
            break;
          }
          throw new Error('Unlock transaction clone is unavailable.');
        case 3:
          _finalTx = mod.cloneTransactionSkeleton(base);
          assignOutputSlipIndices(_finalTx);
          mod.unlock_transaction_final = _finalTx;
          if (typeof mod.cloneUnlockCandidate === 'function') {
            mod.cloneUnlockCandidate();
          }
          return _context5.a(2, _finalTx);
        case 4:
          _context5.n = 5;
          return readSpendableWalletNolan(app);
        case 5:
          balance = _context5.v;
          if (!(balance < feeNolan)) {
            _context5.n = 7;
            break;
          }
          have = app.wallet.convertNolanToSaito(balance);
          _context5.n = 6;
          return debugFeeFundWalletState(app, 'precheck-insufficient', {
            unlockFee: mod.unlock_fee,
            feeNolan: feeNolan.toString(),
            feeNolanType: _typeof(feeNolan),
            balancePrecheck: balance.toString(),
            balanceSaito: have
          });
        case 6:
          throw new Error("Insufficient wallet balance to fund this fee. Available: ".concat(have, " SAITO."));
        case 7:
          _context5.n = 8;
          return app.wallet.getPublicKey();
        case 8:
          me = _context5.v;
          if (me) {
            _context5.n = 9;
            break;
          }
          throw new Error('Could not read your wallet public key.');
        case 9:
          _context5.n = 10;
          return debugFeeFundWalletState(app, 'before-createUnsignedTransaction', {
            unlockFee: mod.unlock_fee,
            feeSaito: (_mod$unlock_fee = mod.unlock_fee) === null || _mod$unlock_fee === void 0 ? void 0 : _mod$unlock_fee.feeSaito,
            feeNolanStored: (_mod$unlock_fee2 = mod.unlock_fee) === null || _mod$unlock_fee2 === void 0 ? void 0 : _mod$unlock_fee2.feeNolan,
            feeNolan: feeNolan.toString(),
            feeNolanType: _typeof(feeNolan),
            amountArg: '0',
            amountArgType: _typeof(BigInt(0)),
            me: me,
            meType: _typeof(me),
            balancePrecheck: balance.toString(),
            balancePrecheckSaito: app.wallet.convertNolanToSaito(balance),
            baseInputCount: Array.isArray(base === null || base === void 0 ? void 0 : base.from) ? base.from.length : null,
            baseOutputCount: Array.isArray(base === null || base === void 0 ? void 0 : base.to) ? base.to.length : null
          });
        case 10:
          _context5.p = 10;
          _context5.n = 11;
          return app.wallet.createUnsignedTransaction(me, BigInt(0), feeNolan);
        case 11:
          feeTx = _context5.v;
          _context5.n = 15;
          break;
        case 12:
          _context5.p = 12;
          _t14 = _context5.v;
          _context5.n = 13;
          return readSpendableWalletNolan(app);
        case 13:
          balanceAfter = _context5.v;
          _have = app.wallet.convertNolanToSaito(balanceAfter);
          detail = _t14 !== null && _t14 !== void 0 && _t14.message ? " (".concat(_t14.message, ")") : '';
          _context5.n = 14;
          return debugFeeFundWalletState(app, 'createUnsignedTransaction-threw', {
            unlockFee: mod.unlock_fee,
            feeNolan: feeNolan.toString(),
            feeNolanType: _typeof(feeNolan),
            me: me,
            balanceBefore: balance.toString(),
            balanceAfter: balanceAfter.toString(),
            balanceAfterSaito: _have,
            errName: _t14 === null || _t14 === void 0 ? void 0 : _t14.name,
            errMessage: _t14 === null || _t14 === void 0 ? void 0 : _t14.message,
            errString: String(_t14),
            errStack: _t14 === null || _t14 === void 0 ? void 0 : _t14.stack,
            // Wasm / JS often stash the real cause here
            errCauseMessage: _t14 === null || _t14 === void 0 || (_err$cause = _t14.cause) === null || _err$cause === void 0 ? void 0 : _err$cause.message,
            errKeys: _t14 && _typeof(_t14) === 'object' ? Object.keys(_t14) : []
          });
        case 14:
          console.error('[RustScript fee-fund] createUnsignedTransaction raw err', _t14);
          throw new Error("Could not fund the transaction fee from your wallet. Available: ".concat(_have, " SAITO.").concat(detail));
        case 15:
          if (feeTx) {
            _context5.n = 17;
            break;
          }
          _context5.n = 16;
          return debugFeeFundWalletState(app, 'createUnsignedTransaction-returned-null', {
            feeNolan: feeNolan.toString(),
            me: me
          });
        case 16:
          throw new Error('Could not fund the transaction fee from your wallet.');
        case 17:
          if (!(typeof mod.cloneTransactionSkeleton !== 'function')) {
            _context5.n = 18;
            break;
          }
          throw new Error('Unlock transaction clone is unavailable.');
        case 18:
          finalTx = mod.cloneTransactionSkeleton(base);
          feeInputs = Array.isArray(feeTx.from) ? feeTx.from : [];
          fundedInputCount = 0;
          skippedFeeInputs = [];
          i = 0;
        case 19:
          if (!(i < feeInputs.length)) {
            _context5.n = 22;
            break;
          }
          stored = slipToJson(feeInputs[i]);
          if (!(!stored || !slipAmountPositive(stored))) {
            _context5.n = 20;
            break;
          }
          skippedFeeInputs.push({
            index: i,
            reason: !stored ? 'no-json' : 'non-positive-amount',
            amount: (stored === null || stored === void 0 ? void 0 : stored.amount) != null ? String(stored.amount) : null
          });
          return _context5.a(3, 21);
        case 20:
          finalTx.addFromSlip(new Slip(undefined, stored));
          fundedInputCount += 1;
        case 21:
          i++;
          _context5.n = 19;
          break;
        case 22:
          if (!(fundedInputCount === 0)) {
            _context5.n = 24;
            break;
          }
          _context5.n = 23;
          return debugFeeFundWalletState(app, 'no-positive-fee-inputs-on-feeTx', {
            feeNolan: feeNolan.toString(),
            feeTxFromCount: feeInputs.length,
            feeTxToCount: Array.isArray(feeTx.to) ? feeTx.to.length : 0,
            skippedFeeInputs: skippedFeeInputs,
            feeTxFrom: feeInputs.map(function (s, i) {
              var j = slipToJson(s);
              return {
                i: i,
                amount: (j === null || j === void 0 ? void 0 : j.amount) != null ? String(j.amount) : null,
                publicKey: (j === null || j === void 0 ? void 0 : j.publicKey) || (j === null || j === void 0 ? void 0 : j.public_key) || null
              };
            })
          });
        case 23:
          throw new Error('Wallet returned no spendable inputs for this fee. Check that your wallet has confirmed SAITO available.');
        case 24:
          changeOuts = Array.isArray(feeTx.to) ? feeTx.to : [];
          _i = 0;
        case 25:
          if (!(_i < changeOuts.length)) {
            _context5.n = 28;
            break;
          }
          _stored = slipToJson(changeOuts[_i]);
          if (!(!_stored || !slipAmountPositive(_stored))) {
            _context5.n = 26;
            break;
          }
          return _context5.a(3, 27);
        case 26:
          finalTx.addToSlip(new Slip(undefined, _stored));
        case 27:
          _i++;
          _context5.n = 25;
          break;
        case 28:
          assignOutputSlipIndices(finalTx);
          console.warn('[RustScript fee-fund]', {
            label: 'funded-ok',
            feeNolan: feeNolan.toString(),
            fundedInputCount: fundedInputCount,
            skippedFeeInputs: skippedFeeInputs,
            finalFrom: Array.isArray(finalTx.from) ? finalTx.from.length : 0,
            finalTo: Array.isArray(finalTx.to) ? finalTx.to.length : 0
          });
          mod.unlock_transaction_final = finalTx;
          if (typeof mod.cloneUnlockCandidate === 'function') {
            mod.cloneUnlockCandidate();
          }
          return _context5.a(2, finalTx);
      }
    }, _callee5, null, [[10, 12]]);
  }));
  return _ensureUnlockFeeFunded.apply(this, arguments);
}
function prepareUnlockForSigning(_x10, _x11, _x12) {
  return _prepareUnlockForSigning.apply(this, arguments);
}
function _prepareUnlockForSigning() {
  _prepareUnlockForSigning = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(app, mod, message) {
    var finalTx, authMessage;
    return _regenerator().w(function (_context6) {
      while (1) switch (_context6.n) {
        case 0:
          _context6.n = 1;
          return ensureUnlockFeeFunded(app, mod);
        case 1:
          finalTx = _context6.v;
          authMessage = buildP2shAuthMessage(app, message, finalTx);
          return _context6.a(2, {
            finalTx: finalTx,
            authMessage: authMessage
          });
      }
    }, _callee6);
  }));
  return _prepareUnlockForSigning.apply(this, arguments);
}
function markUnlockImmutable(mod) {
  if (mod) {
    mod.unlock_transaction_editable = false;
  }
}
function clearUnlockFee(mod) {
  var mainUi = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  if (!mod) {
    return;
  }
  mod.unlock_fee = null;
  mod.unlock_transaction_final = null;
  if (typeof mod.cloneUnlockCandidate === 'function' && mod.unlock_transaction_base) {
    mod.cloneUnlockCandidate();
  }
  if (mainUi) {
    mainUi.executionStatus = {
      attempted: false,
      success: false
    };
    mainUi.validationDisplay = null;
  }
}
module.exports = {
  UNLOCK_SIGNED_ERROR: UNLOCK_SIGNED_ERROR,
  UNLOCK_FEE_LOCKED_ERROR: UNLOCK_FEE_LOCKED_ERROR,
  hasUnlockFee: hasUnlockFee,
  isDefaultZeroUnlockFee: isDefaultZeroUnlockFee,
  canChangeUnlockFee: canChangeUnlockFee,
  ensureDefaultUnlockFee: ensureDefaultUnlockFee,
  isUnlockEditable: isUnlockEditable,
  assertUnlockEditable: assertUnlockEditable,
  assertUnlockMutablePath: assertUnlockMutablePath,
  isWitnessSignaturePath: isWitnessSignaturePath,
  lockedInputCount: lockedInputCount,
  userOutputs: userOutputs,
  formatFeeAmount: formatFeeAmount,
  lockUnlockFeeAmount: lockUnlockFeeAmount,
  applyUnlockFee: applyUnlockFee,
  ensureUnlockFeeFunded: ensureUnlockFeeFunded,
  prepareUnlockForSigning: prepareUnlockForSigning,
  buildP2shAuthMessage: buildP2shAuthMessage,
  getP2shAuthHash: getP2shAuthHash,
  assignOutputSlipIndices: assignOutputSlipIndices,
  markUnlockImmutable: markUnlockImmutable,
  clearUnlockFee: clearUnlockFee,
  invalidateUnlockSignatures: invalidateUnlockSignatures,
  clearSignatureWitnesses: clearSignatureWitnesses,
  // Compatibility stubs — fee funding is no longer shown in the UI.
  isFeeInputSlip: function isFeeInputSlip() {
    return false;
  },
  isChangeOutputSlip: function isChangeOutputSlip() {
    return false;
  },
  walletFeeInputRows: function walletFeeInputRows() {
    return [];
  }
};